(function(angular) {
    'use strict';

    var DmsMainCtrl = (function() {
        var _$inject = ['$scope', '$q', '$state', 'dmsFolderService', 'dmsAccess', 'dmsPermission', 'folderManager', 'dmsHideTreeViewService', 'appOnvioDesignComponentesService'];
        var reloadedOnce = false;
        function DmsMainCtrlImpl($scope, $q, $state, dmsFolderService, dmsAccess, dmsPermission, folderManager, dmsHideTreeViewService, appOnvioDesignComponentesService) {
            var vm = this;

            vm.activeIndex = null;

            appOnvioDesignComponentesService.defineOnvioDesignComponents();
            var clientFolderType = 'taxaccounting';
            var firmFolderType = 'firmTaxAndAccountingLibrary';
            var myFolderType = 'myTaxAndAccountingLibraries';

            var showAllDocs = $q.all([
                dmsAccess.has('DMS_HideRecentActivity'),
                dmsAccess.has('DMS_HideDocumentActivity'),
                dmsPermission.has('OnvioDrive.Documents')
            ]).then(function(result) {
                return !result[0] && result[1] && result[2];
            });

            var showDocumentActivity = $q.all([
                dmsAccess.has('DMS_HideRecentActivity'),
                dmsAccess.has('DMS_HideDocumentActivity'),
                dmsPermission.has('OnvioDrive.DocumentActivity')
            ]).then(function(result) {
                return !result[0] && !result[1] && result[2];
            });

            var showRecent = $q.all([
                dmsAccess.has('DMS_HideRecentActivity'),
                dmsAccess.has('DMS_HideDocumentActivity'),
                dmsPermission.has('OnvioDrive.RecentActivity')
            ]).then(function(result) {
                return !result[0] && result[1] && result[2];
            });

            var showRecycle = $q.all([
                dmsAccess.has('DMS_HideRecycleBin'),
                dmsPermission.has('OnvioDrive.RecycleBin')
            ]).then(function(result) {
                return !result[0] && result[1];
            });

            function folderByType(type) {
                return function(folder) {
                    return folder.type === type;
                };
            }

            var rootFoldersPromise = folderManager.getAllRootFolders().then(function(result) {
                return result.data;
            });

            var myDocsPromise = rootFoldersPromise.then(function(folders) {
                return _.find(folders, folderByType(myFolderType));
            });
            var firmDocsPromise = rootFoldersPromise.then(function(folders) {
                return _.find(folders, folderByType(firmFolderType));
            });

            function goToFolder(folder) {
                $state.go('folderList', { folderId: folder.id });
            }

            function setActiveTab() {
                vm.tabs.forEach(function(tab) {
                    tab.isSelected().then(function(selected) {
                        if (selected) {
                            vm.activeIndex = tab.index;
                        }
                    });
                });
            }

            function rootFolderTypeIs(type) {
                var folderId = $state.params.folderId;
                // This is cached at the service level
                return dmsFolderService.getAncestors(folderId).then(function(ancestors) {
                    return ancestors.data.rootType.toLowerCase() === type.toLowerCase();
                });
            }

            function stateIs(stateName) {
                return !!$state.current.name.match(stateName);
            }

            function stateIsTreeView(stateDrawer) {
                return $state.current.name.startsWith('TreeView') &&
                    $state.params.drawer &&
                    stateDrawer &&
                    $state.params.drawer.toLowerCase() === stateDrawer.toLowerCase();
            }

            vm.showTabs = function() {
                return (vm.activeIndex !== null) && !stateIs(/^template/) && !stateIs(/^requestTemplate/);
            };

            function Tab(config) {
                var _this = this;

                // Will be set after all are created
                _this.index = -1;
                _this.label = config.label;
                _this.icon = config.icon;

                _this.select = config.select;
                _this.isSelected = function() {
                    // Some return promises, some don't. Unify them by making all promises
                    return $q.resolve(config.isSelected());
                };

                $q.resolve(config.show).then(function(show) {
                    _this.visible = show;
                });
            }

            vm.tabs = [
                new Tab({
                    // All Documents
                    label: /* i18nextract */'Onvio.Shell.Navigation.Documents',
                    icon: 'bento-icon-group',
                    show: showAllDocs,
                    select: $state.go.bind($state, 'allDocsRootList'),
                    isSelected: stateIs.bind(null, 'allDocsRootList')
                }),
                new Tab({
                    // Client Documents
                    label: /* i18nextract */'Onvio.Shell.Navigation.ClientDocuments',
                    icon: 'bento-icon-users',
                    show: dmsPermission.has('OnvioDrive.ClientDocuments'),
                    select: function() {
                        dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
                            if (hideTreeView) {
                                $state.go('clientRootList');
                            } else {
                                $state.go('TreeView', {
                                    drawer: 'client',
                                    drawerId: null,
                                    containerId: null,
                                    containerType: null,
                                    document: null,
                                    documentId: null
                                });
                            }
                        });
                    },
                    isSelected: function() {
                        return stateIsTreeView('client') ||
                            stateIs(/^(client|project)/) ||
                            (stateIs('folderFileView') && rootFolderTypeIs(clientFolderType));
                    }
                }),
                new Tab({
                    // Firm Documents
                    label: /* i18nextract */'Bluemoon.DMS.SpecialFolders.FirmDocuments',
                    icon: 'bento-icon-building',
                    show: dmsPermission.has('OnvioDrive.FirmDocuments'),
                    select: function() {
                        dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
                            if (hideTreeView) {
                                firmDocsPromise.then(goToFolder);
                            } else {
                                firmDocsPromise.then(function(folder) {
                                    $state.go('TreeView', {
                                        drawer: 'firm',
                                        drawerId: folder.id,
                                        containerId: null,
                                        containerType: null,
                                        document: null,
                                        documentId: null
                                    });
                                });
                            }
                        });
                    },
                    isSelected: function() {
                        return stateIsTreeView('firm') ||
                            stateIs(/^folder/) && rootFolderTypeIs(firmFolderType);
                    }
                }),
                new Tab({
                    // My Documents
                    label: /* i18nextract */'Bluemoon.DMS.SpecialFolders.MyDocuments',
                    icon: 'bento-icon-user',
                    show: dmsPermission.has('OnvioDrive.MyDocuments'),
                    select: function() {
                        dmsHideTreeViewService.hideTreeView().then(function(hideTreeView) {
                            if (hideTreeView) {
                                myDocsPromise.then(goToFolder);
                            } else {
                                myDocsPromise.then(function(folder) {
                                    $state.go('TreeView', {
                                        drawer: 'my',
                                        drawerId: folder.id,
                                        containerId: null,
                                        containerType: null,
                                        document: null,
                                        documentId: null
                                    });
                                });
                            }
                        });
                    },
                    isSelected: function() {
                        return stateIsTreeView('my') ||
                            stateIs(/^folder/) && rootFolderTypeIs(myFolderType);
                    }
                }),
                new Tab({
                    // Recent Documents
                    label: /* i18nextract */'Bluemoon.DMS.SpecialFolders.Recents',
                    icon: 'bento-icon-history',
                    show: showRecent,
                    select: $state.go.bind($state, 'legacyRecentsList'),
                    isSelected: stateIs.bind(null, 'legacyRecentsList')
                }),
                new Tab({
                    // Document Activity
                    label: /* i18nextract */'Bluemoon.DMS.SpecialFolders.DocumentActivity',
                    icon: 'bento-icon-history',
                    show: showDocumentActivity,
                    select: $state.go.bind($state, 'recentsList'),
                    isSelected: stateIs.bind(null, 'recentsList')
                }),
                new Tab({
                    // Recycle Bin
                    label: /* i18nextract */'Bluemoon.DMS.SpecialFolders.RecycleBin',
                    icon: 'bento-icon-remove',
                    show: showRecycle,
                    select: $state.go.bind($state, 'recycleList'),
                    isSelected: stateIs.bind(null, 'recycleList')
                }),
                new Tab({
                    // Search - Invisible tab
                    show: false,
                    isSelected: stateIs.bind(null, 'documentSearch')
                }),
                new Tab({
                    // Communications
                    label: /* i18nextract */'Bluemoon.DMS.SpecialFolders.Communications',
                    icon: 'bento-icon-history',
                    show: dmsPermission.has('OnvioDrive.Communications'),
                    select: $state.go.bind($state, 'communicationsList'),
                    isSelected: stateIs.bind(null, /^communications/)
                }),
            ];

            // Tabs need to know their own index because that's how
            // uib-tabset knows which one is selected.
            vm.tabs.forEach(function(tab, i) {
                tab.index = i;
            });

            $scope.$on('$stateChangeSuccess', setActiveTab);

            setActiveTab();

            // reload this very first state of the app exactly once to trigger a $stateChangeStart event.
            // ($stateChangeStart doesn't fire for the very first state the app loads, but we need it to
            // for the tree nav/legacy rerouting code to execute)
            if (!reloadedOnce) {
                reloadedOnce = true;
                setTimeout(function() {
                    $state.reload();
                }, 0);
            }
        }

        DmsMainCtrlImpl.$inject = _$inject;
        return DmsMainCtrlImpl;
    }());

    angular.module('onvio.documents')
        .controller('dmsMainCtrl', DmsMainCtrl);

})(window.angular);
